import { FC, useState } from 'react';
import classNames from 'classnames';
import { Icon } from 'common-components';
import styles from './iconSelection.module.scss';
import { useTranslationContext } from '../../contexts/translationContext';
import { IconSelectionProps } from './iconSelectionTypes';

const IconSelection: FC<IconSelectionProps> = (props: IconSelectionProps) => {
    const { icons, selectedIcon, onSelection, defaultIcon } = props;
    const [hoveredIcon, setHoveredIcon] = useState<string>('');

    const { translate } = useTranslationContext();

    const MORE_OPTIONS = translate('MoreOptions');

    const renderSelectedIcon = (iconUrl: string) => {
        return (
            <div
                className={classNames(styles['selected-wrapper'], {
                    [styles['hovered-icon']]: hoveredIcon === iconUrl && hoveredIcon !== selectedIcon
                })}
            >
                <Icon name="done" className={styles['selected-icon']} />
            </div>
        );
    };

    return (
        <div className={styles.container}>
            <div className={styles['default-icon-container']}>
                <div
                    className={classNames(styles['default-icon'], styles['icon-essentials'])}
                    style={{ background: `url(${defaultIcon.url}) center center / cover no-repeat` }}
                    onMouseEnter={() => setHoveredIcon(defaultIcon.url)}
                    onMouseLeave={() => setHoveredIcon('')}
                    onClick={() => onSelection(defaultIcon.url)}
                />
                {defaultIcon.title && <span className={styles['default-icon-title']}>{defaultIcon.title}</span>}
                {(selectedIcon === defaultIcon.url || hoveredIcon === defaultIcon.url) &&
                    renderSelectedIcon(defaultIcon.url)}
            </div>
            <div>
                <span className={styles.title}>{MORE_OPTIONS}</span>
            </div>
            <div className={styles['icons-container']}>
                {icons.map((icon, index) => {
                    return (
                        <div key={index} className={styles['icon-wrapper']}>
                            <div className={styles['icon-container']}>
                                <div
                                    className={classNames(styles.icon, styles['icon-essentials'])}
                                    style={{ background: `center no-repeat url(${icon.url})`, backgroundSize: 'cover' }}
                                    onClick={() => onSelection(icon.url)}
                                    onMouseEnter={() => setHoveredIcon(icon.url)}
                                    onMouseLeave={() => setHoveredIcon('')}
                                />
                                {icon.title && <span className={styles['icon-title']}>{icon.title}</span>}
                            </div>
                            {(hoveredIcon === icon.url || selectedIcon === icon.url) && renderSelectedIcon(icon.url)}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default IconSelection;
